import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { e: String, s: String }

  connect() {
    const email = atob(this.eValue)
    const subject = this.hasSValue ? atob(this.sValue) : null
    const href = subject ? `mailto:${email}?subject=${encodeURIComponent(subject)}` : `mailto:${email}`
    const classes = this.element.dataset.linkClass || ""

    const a = document.createElement("a")
    a.href = href
    a.className = classes
    a.textContent = email
    this.element.replaceWith(a)
  }
}
